<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>应用趋势分析</span>
        </div>
        <div class="time-box">
            <div class="time-type" @click="changeTimeType('day')" :class="timeType == 'day' ? 'is-select' : ''">日</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('week')" :class="timeType == 'week' ? 'is-select' : ''">周</div>
            <div class="line"></div>
            <div class="time-type" @click="changeTimeType('month')" :class="timeType == 'month' ? 'is-select' : ''">月</div>
        </div>
        <div class="more" @click="gotoSchoolList">
            应用详情 >
        </div>
        <div class="content" :style="contentStyleObj">
            <div style="width:100%;height: 100%" id="visitEchartsId" v-if="!noData"></div>
            <div v-if="noData" style="font-size: 18px;margin-top: 10%;">暂无数据！</div>
        </div>
    </div>
</template>

<script>
import { findTeacherHwNumDayList } from '../../../service/bigDataApi'

export default {
    name: "pie-item",
    data() {
        return {
            screenWidth: 0, //屏幕宽度
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: '',
                marginTop: '0px'
            },
            channel: process.env.VUE_APP_CHANNEL,
            timeType: "week",
            noData: false,
            echartsInstance: null, // 新增属性，用于存储当前的 ECharts 实例
            }
    },
    props: {
        SchoolDayActive: {
            type: Array,
            default: function () {
                return []
            }
        },
        SchoolWeekActive: {
            type: Array,
            default: function () {
                return []
            }
        },
        SchoolMonthActive: {
            type: Array,
            default: function () {
                return []
            }
        },
        screenHeight: Number,
        titleHeight: Number
    },
    watch: {
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight',
        'SchoolWeekActive': 'initEcharts',
    },
    methods: {
        changeTimeType(type) {
            this.noData = false;
            this.timeType = type
            this.$nextTick(() => {
                this.initEcharts();
            }
            )

        },
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 10;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        /**
         * 加载饼状图
         */
        initEcharts() {
            let option;
            let data = []; let date = [];
             // 销毁旧的 ECharts 实例
            if (this.echartsInstance) {
                this.echartsInstance.dispose();
            }
            if (this.timeType == 'day' && this.SchoolDayActive.length) {
                data = JSON.parse(JSON.stringify(this.SchoolDayActive))
                date = data[0].timeList.map(subItem => subItem.day)
            } else if (this.timeType == 'week' && this.SchoolWeekActive.length) {
                data = JSON.parse(JSON.stringify(this.SchoolWeekActive))
                date = data[0].timeList.map(subItem => subItem.weekYearName)
            } else if (this.timeType == 'month' && this.SchoolMonthActive.length) {
                data = JSON.parse(JSON.stringify(this.SchoolMonthActive))
                date = data[0].timeList.map(subItem => subItem.monthYearName)
            } else {
                this.noData = true;
                return
            }
            data.sort((a, b) => {
                const order = [1, 4, 2, 3];
                return order.indexOf(a.type) - order.indexOf(b.type);
            });
            option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: date,
                    name: "时间",
                    axisLabel: {
                        textStyle: {
                            color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
                        },
                        interval: this.timeType == 'month' ? 0 : 7,
                    },
                    nameTextStyle: {  // 这里设置Y轴名称文字的样式  
                        color: '#6EA0D3',  // 这里将颜色设置为红色  
                        fontSize: 12   // 还可以设置字体大小等其他样式  
                    },
                },
                yAxis: {
                    type: 'value',
                    name: "访问数量",
                    splitLine: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#6EA0D3' // 设置横线格栅颜色
                        }
                    },
                    axisLine: {
                        show: false // 不显示 y 轴线条
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#6EA0D3' // 这里设置X轴刻度文字颜色  
                        }
                    },
                    nameTextStyle: {  // 这里设置Y轴名称文字的样式  
                        color: '#6EA0D3',
                        fontSize: 12   // 还可以设置字体大小等其他样式  
                    },
                },
                grid: {
                    left: "20px",
                    right: "60px",
                    top: "30px",
                    bottom: "0",
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'item', // 触发类型，'item' 表示触发 tooltip 的是数据项本身，'axis' 表示触发 tooltip 的是坐标轴
                    formatter: function (params) {
                        // params 是一个包含了当前数据项信息的对象
                        return '日期：' + params.name + '<br>' + params.seriesName + '访问量：' + params.value;
                    },
                },
                legend: {
                    right: '10',
                    data: data.map(item => item.name),
                    itemWidth: 10,  // 设置图例项的宽度
                    itemHeight: 10, // 设置图例项的高度
                    icon: "circle",
                    textStyle: {
                        color: '#6EA0D3'  // 设置图例标签文字颜色为红色
                    }
                },
                series: [
                    {
                        show: data[0] ? true : false,
                        data: data[0] ? data[0].timeList.map(subItem => subItem.count) : [],
                        name: data[0] ? data[0].name : '',
                        // color:"#43AAEC",
                        smooth: true,
                        type: 'line',
                        lineStyle: {
                            color: '#43AAEC'
                        },
                        itemStyle: {
                            color: '#43AAEC',
                            borderRadius: 0
                        },
                        symbolSize: 5, // 设置折线上圆点大小
                        symbol: 'circle', // 设置拐点为实心圆
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#061135' },   // 0% 处的颜色  
                                    { offset: 1, color: '#245D7C' }   // 100% 处的颜色  
                                ],
                                global: false   // 缺省为 false  
                            }
                        }
                    },
                    {
                        show: data[1] ? true : false,
                        data: data[1] ? data[1].timeList.map(subItem => subItem.count) : [],
                        name: data[1] ? data[1].name : '',
                        smooth: true,
                        type: 'line',
                        symbolSize: 5, // 设置折线上圆点大小
                        symbol: 'circle', // 设置拐点为实心圆
                        lineStyle: {
                            color: '#24AA6E'
                        },
                        itemStyle: {
                            color: '#24AA6E'
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#061135' },   // 0% 处的颜色  
                                    { offset: 1, color: '#245D7C' }   // 100% 处的颜色  
                                ],
                                global: false   // 缺省为 false  
                            }
                        }
                    },
                    {
                        show: data[2] ? true : false,
                        data: data[2] ? data[2].timeList.map(subItem => subItem.count) : [],
                        name: data[2] ? data[2].name : '',
                        smooth: true,
                        type: 'line',
                        symbolSize: 5, // 设置折线上圆点大小
                        symbol: 'circle', // 设置拐点为实心圆
                        lineStyle: {
                            color: '#a470eb'
                        },
                        itemStyle: {
                            color: '#a470eb'
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#061135' },   // 0% 处的颜色  
                                    { offset: 1, color: '#245D7C' }   // 100% 处的颜色  
                                ],
                                global: false   // 缺省为 false  
                            }
                        }
                    },
                    {
                        show: data[3] ? true : false,
                        data: data[3] ? data[3].timeList.map(subItem => subItem.count) : [],
                        name: data[3] ? data[3].name : '',
                        smooth: true,
                        type: 'line',
                        symbolSize: 5, // 设置折线上圆点大小
                        symbol: 'circle', // 设置拐点为实心圆
                        lineStyle: {
                            color: '#FF761A'
                        },
                        itemStyle: {
                            color: '#FF761A'
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#061135' },   // 0% 处的颜色  
                                    { offset: 1, color: '#245D7C' }   // 100% 处的颜色  
                                ],
                                global: false   // 缺省为 false  
                            }
                        }
                    },


                ]
            };

            this.echartsInstance = this.$echarts.init(
                document.getElementById("visitEchartsId")
            );
            this.echartsInstance.setOption(option);
            window.addEventListener("resize", function () {
                this.echartsInstance.resize();
            });
        },
        gotoSchoolList() {
            this.$emit("gotoSchoolList");
        }

    },
    mounted() {
        //获取屏幕宽度
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bg2 {
    background-image: url("../../../assets/images/sydataboard/title-bg.png");
}

.time-box {
    position: absolute;
    left: 10px;
    display: inline-flex;
    top: 10%;
    transform: translateY(-50%);
    height: 24px;
    justify-content: space-between;
    color: #359AFF;

    .line {
        width: 1px;
        height: 100%;
        background: linear-gradient(0deg, #061136 0%, #2E87E3 50%, #061136 100%);
        margin: 0 8px;
    }

    .time-type {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #359AFF;
        cursor: pointer;
    }

    .is-select {
        color: #38FFF3;
        border-bottom: 2px solid #38FFF3;
    }

}

.more {
    position: absolute;
    right: 30px;
    display: inline-flex;
    top: 10%;
    cursor: pointer;
    transform: translateY(-50%);
    color: #38FFF3;
}
</style>
